(() => {
  const init = () => {
    document.querySelectorAll('product-info').forEach((root) => {
      const scope = root.querySelector('.product__info-wrapper') || root;
      let queued = false;

      const update = () => {
        queued = false;
        const price = scope.querySelector('.sh-main-price [data-sh-bundler-pricing]');
        const input = scope.querySelector('.bndlr-quantity-break input[name="bundle_quantity"]:checked');
        const option = input?.closest('.bndlr-radio-container');
        const selectedMoney = option?.querySelector('.bndlr-discounted-price[data-currentprice]');
        const displayedMoney = price?.querySelector('.price__sale .price-item--sale [data-currentprice]');
        if (!price || !option || !selectedMoney || !displayedMoney) return;

        const quantity = Number(input.value);
        const total = Number(selectedMoney.dataset.currentprice);
        const displayedTotal = Number(displayedMoney.dataset.currentprice);
        const unitPrice = Number(price.dataset.shUnitPrice);
        const unitCompare = Number(price.dataset.shUnitComparePrice);
        if (!Number.isInteger(quantity) || quantity < 1 || !Number.isFinite(total) ||
            !Number.isFinite(unitPrice) || unitPrice <= 0 || !Number.isFinite(unitCompare) ||
            total !== displayedTotal) return;

        const reference = Math.round(Math.max(unitCompare, unitPrice) * quantity);
        const onSale = total < reference;
        let formatted;
        try {
          formatted = new Intl.NumberFormat(document.documentElement.lang.toLowerCase() === 'pt' ? 'pt-PT' : (document.documentElement.lang || 'en'), {
            style: 'currency',
            currency: price.dataset.shCurrency,
            currencyDisplay: price.dataset.shCurrencyDisplay || 'symbol'
          }).format(reference / 100);
        } catch {
          return;
        }

        price.querySelectorAll('.price__sale s.price-item--regular, .price__regular s.price-item--regular')
          .forEach((node) => {
            if (node.textContent !== formatted) node.textContent = formatted;
          });
        price.classList.toggle('price--on-sale', onSale);
        const percentage = onSale ? Math.round((reference - total) * 100 / reference) : 0;
        const badge = price.querySelector('.price__badge-sale');
        const visible = badge?.querySelector('[aria-hidden="true"]');
        const accessible = badge?.querySelector('.visually-hidden');
        const visibleText = `-${percentage}%`;
        const accessibleText = `${price.dataset.shSaleLabel}: ${percentage}%`;
        if (visible && visible.textContent !== visibleText) visible.textContent = visibleText;
        if (accessible && accessible.textContent !== accessibleText) accessible.textContent = accessibleText;
      };

      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };

      new MutationObserver(schedule).observe(scope, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-currentprice', 'data-bundler-break-active', 'checked']
      });
      root.addEventListener('change', schedule);
      schedule();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

